import React from 'react'
import styles from './styles.module.css'

const General_terms_of_use = () => {
    return (
        <div className={styles.legalPage}>
            <h2 className={styles.legalTitle}>GENERAL TERMS OF USE </h2>
            <div >
                Access to and use of Lynkit’s software platforms and services is governed by this Agreement.
                By using our software platform and services, the Client agrees to become a party to and will be
                bound by all the terms and conditions mentioned here.  This Agreement shall prevail over any
                additional or conflicting terms in other correspondence or documentation submitted by the Client
                to the Company.
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>TERMS OF USE  </div>
                <div>
                    Unless otherwise specified in the Agreement, Client may  access and use the software
                    platform solely for its own business purposes.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>SOFTWARE  </div>
                <div>
                    The software platform may make available for download certain software or
                    documentation. The said software or downloads, and their installation (if any) or its use
                    may be subject to the terms and conditions of use as mentioned therein and the Client
                    will be required to accept the same. Unless otherwise specified in the Agreement, Client
                    may  access and use the software platform solely for its own business purposes.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>CONTENT ON OUR SITES  </div>
                <div>
                    Platform includes a combination of content that the Company creates, or created with
                    third parties, or with partners or licensors or associates. All materials published on the
                    Platform, including, but not limited to written content, photographs, graphics, images,
                    maps, illustrations, marks, logos, sound or video clips, design, texts, artwork, graphic
                    material, databases, proprietary information and/ or otherwise legally protectable
                    elements of the website are protected by copyrights and the trademarks, service marks
                    and logos contained therein and are the property of the Company or those of the
                    Company’s partners or licensors or associates respectively. The Client may not modify,
                    publish, transmit, participate in the transfer or sale of, reproduce, create derivative works
                    of, distribute, publicly perform, publicly display, or in any way exploit any of the materials
                    or content on our software platform in whole or in part. Any unauthorized or prohibited
                    use of any material may be subject to civil liability, criminal prosecution, or both, under
                    applicable laws. The Company reserves the right to modify, reject or eliminate any
                    information residing on or transmitted to any of its servers that it, in its sole discretion,
                    believes is unacceptable or in violation of these terms and conditions and to suspend or
                    end your service for any reason or for violation of these terms and conditions.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>LIMITED LICENSE   </div>
                <div>
                    Except as expressly authorized by the Company in writing, the Client agrees not to sell,
                    license, rent, modify, distribute, copy, reproduce, transmit, publicly display, publish,
                    adapt, edit the content and materials of the software platform or create derivative works
                    from such materials or content.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>CONSENT   </div>
                <div>
                    Without the express prior written authorization of the Company, the Client may not: use
                    any data mining robots ("bots"), hardware or software modules that add a specific
                    feature or service by plugging into an existing larger system ("plug-ins"), or other data
                    gathering and extraction tools, scripts, applications, or methods on this site; use any
                    device, software, or hardware to bypass any operational element or to interfere, or
                    attempt to interfere, with the proper working of this software platform,, server or activities
                    conducted therein; take any action that imposes an unreasonable or disproportionately
                    large load on this site or its network infrastructure or that adversely affects our network
                    or other customers; decompile, reverse engineer, modify or disassemble any of the
                    software in or associated with the network and/or server; use any meta tags or any other
                    "hidden text" utilizing the name of any the Company or any trademark of the Company;
                    frame or utilize framing techniques to enclose any trademark, logo, or other proprietary
                    information (including images, text, page layout, or form) of the Company or use any
                    trademark of the Company except as set forth in the foregoing limited license in these
                    terms of use or in another written agreement between the Client and the Company that
                    is currently in effect at the time of use; or otherwise exceed your limited access to the
                    site as authorized by the Company.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>THIRD-PARTY AUTHORIZATIONS    </div>
                <div>
                    If Client authorize or grant access to any person to upload any information or access any
                    features of the services provided by the Platform based on User details or log in
                    credentials, or avail the services provided by the Platform and/or to use certain
                    segments of the Platform, then the Client will be at all times responsible and liable for
                    access and the activities that are carried out using such authorization by the third party.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>UNAUTHORIZED USE    </div>
                <div>
                    In case of any unauthorized use of account with the Platform, the Client must notify the
                    Company immediately on becoming aware of the same at support@lynkit.io and take all
                    reasonable steps to protect the account with the Platform from being misused in any
                    manner including but not limited to changing the password, authorization code etc. The
                    Company shall not be responsible or liable for any misuse or fraud which is caused as a
                    result of use of the account with the software product and/or if the Client authorized any
                    other person/ entity to use or avail the services from the said account with the software
                    product and/ or with third parties. Only The Client will be personally liable in case of loss
                    or damage caused to the software product or to any third party resulting from your
                    negligence or misuse in protecting account information of the software product or of
                    Third Parties, such as login or password or authorization code or any other
                    authentication material provided to the Client. The Company reserves its rights to take
                    legal action against the user or any person or entity in case of any unauthorized use of
                    this Platform or any other domain names owned by the Company and/or the content or
                    data displayed by the said user or any other person or entity that is unlawful. The Client
                    shall be liable to indemnify and hold the Company harmless from any loss or damage
                    that arises in case of any breach or violation of the terms of use as mentioned hereunder
                    and shall be liable to reimburse all costs and expenses incurred by the Company in
                    defending any claim, demand, suit or proceeding arising from or in connection with such
                    violation or breach.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>THIRD-PARTY SITES, PRODUCTS, AND SERVICES    </div>
                <div>
                    In case of 3rd party integrations owned by third parties,  use of each of those 3rd party
                    digital services is subject to the terms and conditions, if any, that each of those service
                    providers have posted. The Company has no control over the services that are not ours,
                    and are not responsible for any changes to or content on them. The Company agrees
                    that you will not be responsible or liable for any loss or damage incurred as the result of
                    any of your transactions with third parties. Any questions, complaints, or claims related
                    to any product or service should be directed to the appropriate vendor. The Company
                    makes no warranties as to the accuracy and correctness of the content of the links of
                    third parties provided on the Platform at any time.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>INFORMATION UPLOADED BY THE USERS     </div>
                <div>
                    The Platform does not control the information provided by you and it is your duty to
                    ensure that all the information provided by you is true, complete and accurate and not
                    offensive, incomplete, fraudulent, harmful, inaccurate or misleading. The Company is
                    under no obligation to monitor the Content and any other information residing on or
                    transmitted to its servers. However, anyone using the Company’s server agrees that the
                    Company may monitor the server contents at any time to (a) comply with any necessary
                    laws, regulations or other governmental requests; (b) to operate the server properly or to
                    protect itself and its users; or (c) perform any other function relating to the provision of
                    services through the Company’s software.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>FRAUDULENT ACCOUNTS     </div>
                <div>
                    The Company reserves the right to monitor suspicious account activities on our Platform.
                    Accordingly, any user who fraudulently misuses our services through his/ her account
                    shall be liable for legal action under the applicable laws. Further, such user shall also
                    indemnify the Company for the lawyer's fees or other costs that may arise in prosecuting
                    such actions. In such cases, the Company reserves the right to delete the account of the
                    user. For the purpose of this clause, the Company shall owe no liability for any refunds.
                    The Company shall not transfer the Client’s account to another person or party. The
                    Client must also notify us immediately of any unauthorized use of the account of which
                    the Client became aware and change any password or any other authentication material
                    which you believe may have been compromised. The Company disclaims any
                    responsibility for the results of use, misuse or fraud with respect to the specific
                    authorization given by the Client to any person for use of your account. The Client shall
                    be personally liable in case of any violation of any law or loss or damage caused to the
                    Company or to any third party resulting from your negligence in protecting the Client’s
                    authorization details, such as your user name or password or authorization code or
                    authentication material.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>FRAUD    </div>
                <div>
                    We reserve the right to suspend or terminate your account without notice if you have
                    indulged in illegal, prohibited, fraudulent activity, or provided untrue, incomplete, or
                    misrepresented information. The Company also reserves the right to initiate appropriate
                    legal proceedings against the Client as per applicable law, in addition to the action that
                    appropriate Government authorities may take against the Client.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>REPRESENTATIONS & WARRANTIES </div>
                <div>
                    <ol type='i'>
                        <li>Each Party shall at all times comply with all applicable laws, rules and regulations in
                            the performance of this Agreement. </li>
                        <li>Each party is duly organized and existing and is in good standing and is qualified to
                            do business under the laws of any jurisdiction where the ownership of assets or
                            conduct of its business require it to be so qualified, and each party possesses any
                            and all licenses and/or governmental approvals required to perform the Services. </li>
                        <li>Each party’s execution, delivery and performance of this Agreement has been duly
                            authorized by all appropriate corporate action and this Agreement constitutes a valid,
                            binding and enforceable obligation. </li>
                        <li>Neither the execution, delivery, nor performance of this Agreement will conflict with
                            or violate any other agreement, license, contract, instrument or other commitment or
                            arrangement to which either party is a party or is bound all times comply with all
                            applicable laws, rules and regulations in the performance of this Agreement. </li>
                        <li>There is no litigation, and neither Party knows of any material threat of litigation, in
                            each case that will affect the performance of its obligations hereunder. </li>
                        <li>Each Party shall perform its obligations hereunder in accordance with all applicable
                            law and regulations, and shall be responsible for obtaining all licenses,
                            authorizations, permits and the like required by applicable laws and regulations, and
                            any fees, costs or expenses incurred by such Party shall be borne solely by such
                            Party. Each Party shall be solely responsible for any fines and penalties imposed on
                            it or the other Party resulting from such Party’s failure to comply with any such
                            applicable laws and regulations.</li>
                    </ol>
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>TERMINATION </div>
                <div>
                    <ol type='i'>
                        <li>This Agreement may be terminated by either Party by giving the other Party a prior
                            written notice of 30 days, and will be subject to the payment and billing terms
                            mentioned in the sales order.
                        </li>
                        <li>Either Party may terminate this Agreement immediately by notice, the Party has not
                            cured the breach within 2 (Two) days of being notified of the breach as aforesaid. </li>
                        <li>In addition to the breach of conditions under this Agreement, the following events will
                            qualify for immediate termination by Party:
                            <ol type='a'>
                                <li> In the event of receipt of instructions being received from a competent
                                    regulatory / statutory / supervisory authority and/or if required under
                                    applicable laws or the provisions of this Agreement becomes or are contrary
                                    to applicable laws or industry practice. </li>
                                <li>In the event Party becomes bankrupt or insolvent or is dissolved or
                                    liquidated or has become the subject of proceedings under any bankruptcy
                                    or insolvency law or any action has been taken for its reorganization,
                                    liquidation or dissolution or insolvency or bankruptcy or if a receiver or
                                    liquidator has been appointed or distraint has been levied on its assets or
                                    any part thereof or proceedings for recovery of any dues, have commenced
                                    or any order has been passed which has not been vacated for a period of 30
                                    days from the date of passing of such order. </li>
                            </ol>
                        </li>
                        <li>Upon termination the Client shall be liable to pay Lynkit any outstanding amount
                            accrued up to date of termination. </li>
                        <li>Termination of this agreement will also result in suspension of services being given
                            by Lynkit.  </li>
                    </ol>
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>DATA PROTECTION </div>
                <div>
                    Both parties agree to comply with all applicable data protection laws and regulations in
                    India, including the Information Technology Act, 2000, and any rules or regulations made
                    thereunder, as well as the Personal Data Protection Bill (once enacted) and any other
                    relevant legal requirements. Any personal data collected, processed, or stored under this
                    agreement will be used solely for the specific purpose for which it was collected and as
                    necessary to fulfill the obligations of this agreement. Parties will ensure that personal
                    data is kept confidential and will not disclose it to unauthorized third parties without
                    explicit consent, except as required by law. In the event of a data breach involving
                    personal data, the affected party will promptly notify the other party of the breach,
                    providing details about the breach and its potential impact.
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}> INDEMNITY AND LIMITATION OF LIABILITY  </div>
                <div>
                    <ol type='i'>
                        <li>The Client shall, indemnify and keep indemnified the Company, its directors, officers,
                            employees and agents and their respective successors and assigns (an "Indemnified
                            Party") free and harmless from and against any actual and direct losses, (including
                            reasonable attorney's fees), which the Indemnified Party shall have suffered or incurred
                            as a result of any breach by the Client of any of its covenants, representations, warranties
                            or the terms and conditions of this Agreement.
                        </li>
                        <li>The Client will indemnify and keep indemnified the Company defend, harmless against
                            allegations, claims, damages, settlements, fines and penalties and costs, including
                            consultants and attorneys’ fees (collectively, “Claims”) arising out of the Client’s
                            negligence and wilful misconduct (or that of anyone under its control) due to any act or
                            omission under this Agreement.  </li>
                        <li>The Company will defend the Client against any third party suit alleging that Company’s
                            use Platform in accordance with this Agreement, directly infringes any third-party patent
                            or copyright. In no event shall Company be liable to the Client for any special, indirect
                            exemplary or consequential damages arising out of this Agreement. </li>
                    </ol>
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}> CONFIDENTIAL INFORMATION  </div>
                <div>
                    <ol type='i'>
                        <li>Both the Parties agree and acknowledge that during the course of this Agreement, they
                            may receive confidential and proprietary information of the other Party and hereby
                            undertake that they shall, at all times, during the continuance of this Agreement and
                            thereafter, ensure that all the terms and conditions of this Agreement are kept
                            confidential ("Confidential Information") and they shall not disclose any information
                            relating to this Agreement to any third party, without the prior written consent of other
                            Party.
                        </li>
                        <li>The Confidential Information does not include information which (i) is known to the Party
                            at the time of disclosure as evidenced by its written records; or (ii) has become publicly
                            known and made generally available through no wrongful act of the other Party; or (iii)
                            the Party lawfully receives such information from a third party without restriction on
                            disclosure, provided such disclosure is without breach of a non-disclosure obligation; or
                            (iv) has been independently developed by the Party without access to the Confidential
                            Information.  </li>
                        <li>The Parties shall immediately upon request by the other Party deliver to the other Party
                            all Confidential Information in its possession or control and/or on request of the other
                            Party destroy or have destroyed all Confidential information in its possession or control,
                            including all copies (if any) within seven (7) days of receipt of the request. The Parties
                            shall certify and declare that they have complied with the provisions herein and that they
                            have delivered and/or destroyed all materials containing Confidential Information. </li>
                    </ol>
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  INTELLECTUAL PROPERTY RIGHTS  </div>
                <div>
                    <ol type='i'>
                        <li>The Parties acknowledge and agree that nothing in this Agreement shall confer or
                            deemed to be conferred on the other party, any right (including Intellectual Property
                            Rights), title or interest in each party’s intellectual property.
                        </li>
                        <li>All Intellectual Property Rights which may hereinafter be disclosed or provided by each
                            party to the other party shall, remain the exclusive property of the Party and the parties
                            shall not use or authorize the use of any such Intellectual Property Rights otherwise than
                            as expressly permitted by the Party and for the purposes stated herein.   </li>
                        <li>The Parties agree and undertake that they will not have any proprietary rights in
                            Intellectual Property Rights of other party or any Confidential Information as disclosed to
                            the other party during their contractual relationship with Parties.
                        </li>
                    </ol>
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  NOTICES  </div>
                <div>
                    Any notice or request required to be permitted to be given or made under this Agreement
                    to the Parties shall be given in writing in English language. Such notice or request shall
                    be deemed to have been duly given or made when it shall be delivered by hand, mail or
                    email confirmation received from the Party to which it shall be delivered as per the
                    address given below:
                </div>
                <br />
                <div>For Company: </div>
                <div>Address: Lynkit Solutions Private Limited, 246, A-Block, Okhla Industrial Area, Phase – I, New Delhi - 110020 </div>
                <div>E-mail:  legal@lynkit.in </div> <br />
                <div>For Client: </div>
                <div>Kind Attn:  </div>
                <div>Address:  </div>
                <div>E-mail:</div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  GOVERNING LAW AND DISPUTE RESOLUTION  </div>
                <div>
                    This Agreement shall be governed by and construed in accordance with the laws of
                    India. Any dispute arising out of or in relation to this Agreement shall be subject to the
                    exclusive jurisdiction of the courts at New Delhi, India.
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  FORCE MAJEURE    </div>
                <div>
                    No Party shall be liable to the other, or shall be in default if, and to the extent, that the
                    performance or delay in performance of any of its obligations under this Agreement is
                    prevented, restricted, delayed or interfered with due to circumstances beyond the
                    reasonable control of such Party including but not limited to applicable Laws, fires,
                    floods, tsunami, explosions, epidemics, pandemics, diseases, accidents, acts of God,
                    threat of wars, riots, strikes, lockouts, or other concerted acts of workmen, acts and rules
                    & regulations of Government, terrorist attacks(hereinafter referred to as “Force Majeure
                    Events”). The affected Party shall inform the other Party in writing of such Force Majeure
                    Event and the reasons of delay along with the reasonable time to overcome such delay.
                    In such, a situation both Parties’ liability would be postponed till further notice under this
                    Agreement and then both the Parties shall discuss the course of action to be taken
                    afterwards.
                </div>
            </div>
            <br />

            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  COUNTERPART   </div>
                <div>
                    This Agreement may be executed in multiple counterparts. Each counterpart shall be
                    treated as an original and shall be capable of being enforced without reliance on the
                    other counterparts as an original document.
                </div>
            </div>
            <br /> 
        </div>
    )
}

export default General_terms_of_use